import { PriceListType, Unit } from '@rematter/frontend-lib-api-client';

import { ItemPricingRecord } from '../types/pricing';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const itemPricingsQueryAtom = createQueryAtomFactory(
  'brokerage.itemPricings',
  (params: {
    priceListId: string;
    priceListType: PriceListType;
    asOf?: string;
  }) => ({
    itemPricings: {
      __args: {
        priceListId: params.priceListId,
        priceListType: params.priceListType,
        ...(params.asOf ? { asOf: params.asOf } : {}),
      },
      id: true,
      item: {
        id: true,
        name: true,
        itemGroupId: true,
        itemGroup: {
          id: true,
          name: true,
        },
      },
      pricingUnit: true,
      position: true,
      tiersEffectiveAt: true,
      tiers: {
        id: true,
        maxAmount: true,
        minPrice: {
          formula: true,
          variableIds: true,
        },
        targetPrice: {
          formula: true,
          variableIds: true,
        },
        maxPrice: {
          formula: true,
          variableIds: true,
        },
        scrapValue: true,
        position: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data): ItemPricingRecord[] => {
      if (!data?.itemPricings) return [];

      return data.itemPricings.map((pp) => ({
        id: pp.id,
        item: {
          id: pp.item.id,
          name: pp.item.name,
          itemGroup: pp.item.itemGroup
            ? { id: pp.item.itemGroup.id, name: pp.item.itemGroup.name }
            : null,
        },
        pricingUnit: pp.pricingUnit as Unit,
        position: pp.position,
        tiersEffectiveAt: pp.tiersEffectiveAt
          ? parseZonedDateTime(pp.tiersEffectiveAt)
          : null,
        tiers: pp.tiers.map((tier) => ({
          id: tier.id,
          maxAmount: tier.maxAmount != null ? Number(tier.maxAmount) : null,
          minPrice: {
            formula: tier.minPrice.formula,
            variableIds: tier.minPrice.variableIds,
          },
          targetPrice: {
            formula: tier.targetPrice.formula,
            variableIds: tier.targetPrice.variableIds,
          },
          maxPrice: {
            formula: tier.maxPrice.formula,
            variableIds: tier.maxPrice.variableIds,
          },
          scrapValue: Number(tier.scrapValue),
          position: tier.position,
          timestamps: {
            createdAt: parseZonedDateTime(tier.timestamps.createdAt),
            updatedAt: parseZonedDateTime(tier.timestamps.updatedAt),
          },
        })),
        timestamps: {
          createdAt: parseZonedDateTime(pp.timestamps.createdAt),
          updatedAt: parseZonedDateTime(pp.timestamps.updatedAt),
        },
      }));
    },
  },
);

export const productPricingsQueryAtom = itemPricingsQueryAtom;
